import React, { Component } from 'react';
import { connect } from 'react-redux';

class NoMatch extends Component {
    render() {
        return (
            <div className="container">
                <p>NotFound1</p>
            </div>
        );
    }
}


export default connect(null, null)(NoMatch);


// WEBPACK FOOTER //
// ./src/components/noMatch.js